import { QuotaPayload } from '../../shared/interfaces/quota.interface';
import {
  DeselectQuotaMatch,
  QuotaDistinct,
  QuotaFilter,
  RemainQuotaMatch,
  SimpleQuotaMatch,
} from './quota-filter';

export interface NestingHandle {
  quotas(): QuotaPayload[];
  missing(): QuotaPayload[];
}

export class ClearAll implements NestingHandle {
  constructor(
    private readonly _originalQuotas: QuotaPayload[],
    private readonly _deselected: number[]
  ) {}

  quotas(): QuotaPayload[] {
    return this._originalQuotas.map((quota) => {
      delete quota.quota_category;
      return quota;
    });
  }
  missing(): QuotaPayload[] {
    return new QuotaFilter(this._originalQuotas).quotas(
      new DeselectQuotaMatch(this._deselected)
    );
  }
}

export class UnNesting implements NestingHandle {
  constructor(
    private readonly _quotas: QuotaPayload[],
    private readonly _originalQuotas: QuotaPayload[],
    private readonly _deselected: number[]
  ) {}

  quotas(): QuotaPayload[] {
    const quotas = new QuotaFilter(this._quotas).quotas(
      new RemainQuotaMatch(this._deselected)
    );

    return [...quotas, ...this.missing()];
  }

  missing(): QuotaPayload[] {
    return new QuotaFilter(this._originalQuotas)
      .quotas(new DeselectQuotaMatch(this._deselected))
      .map((quota) => {
        delete quota.quota_category;
        delete quota.isNested;
        delete quota.group_key;
        return quota;
      });
  }
}

export class NestingQuotaFilter {
  constructor(
    private readonly _quotas: QuotaPayload[],
    private readonly _originalQuotas: QuotaPayload[],
    private readonly _deselected: number[],
    private readonly _nestedIds: number[]
  ) {}

  public filter(): NestingHandle {
    const originalQuotas = new QuotaDistinct(this._quotas, this._originalQuotas)
      .by(new SimpleQuotaMatch())
      .unique();

    if (this._nestedIds.length === 0) {
      return new ClearAll(originalQuotas, this._deselected);
    }

    return new UnNesting(this._quotas, originalQuotas, this._deselected);
  }
}
